export enum TradingInstrumentKind {
  None,
  Futures,
  Stock,
  Forex,
  Option,
  Index
}
